export const DATE_FORMAT_OPTIONS = {
  FULL_DATE: { year: 'numeric', month: 'long', day: 'numeric' }, // November 29, 2024
  SHORT_DATE: { year: 'numeric', month: 'short', day: 'numeric' }, // Nov 29, 2024
  MONTH_YEAR: { year: 'numeric', month: 'long' }, // November 2024
  TIME: { hour: '2-digit', minute: '2-digit' }, // 10:00 AM
  FULL_DATE_TIME: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  }, // November 29, 2024, 10:00:00 AM CET
  SHORT_DATE_TIME: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }, // Nov 29, 2024, 10:00 AM
} as const;
